(function () {
  function initializePartACalculator() {
    var calculator = document.querySelector(".na-part-a-calculator");

    if (!calculator || calculator.getAttribute("data-initialized") === "true") {
      return;
    }

    calculator.setAttribute("data-initialized", "true");

    var tabButtons = calculator.querySelectorAll(".na-tab-button");
    var panels = calculator.querySelectorAll(".na-calculator-panel");

    function getNumber(id) {
      var field = document.getElementById(id);

      if (!field) {
        return NaN;
      }

      return parseFloat(field.value);
    }

    function formatDose(value) {
      if (!Number.isFinite(value)) {
        return "—";
      }

      if (value < 10) {
        return value.toFixed(1) + " mL";
      }

      return Math.round(value * 10) / 10 + " mL";
    }

    function showMessage(element, type, message) {
      if (!element) {
        return;
      }

      element.className = "na-message show " + type;
      element.innerHTML = message;
    }

    function clearMessage(element) {
      if (!element) {
        return;
      }

      element.className = "na-message";
      element.innerHTML = "";
    }

    /* Calculator tabs */
    tabButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var targetId = button.getAttribute("data-target");
        var targetPanel = document.getElementById(targetId);

        tabButtons.forEach(function (tab) {
          tab.classList.remove("active");
          tab.setAttribute("aria-selected", "false");
        });

        panels.forEach(function (panel) {
          panel.classList.remove("active");
        });

        button.classList.add("active");
        button.setAttribute("aria-selected", "true");

        if (targetPanel) {
          targetPanel.classList.add("active");
        }
      });
    });

    /* Calcium correction calculator */
    var correctionButton = document.getElementById(
      "na-calculate-correction"
    );

    if (correctionButton) {
      correctionButton.addEventListener("click", function () {
        var volume = getNumber("na-water-volume");
        var currentCalcium = getNumber("na-current-calcium");
        var targetCalcium = getNumber("na-target-calcium");
        var magnesium = getNumber("na-current-magnesium");

        var message = document.getElementById(
          "na-correction-message"
        );

        var results = document.getElementById(
          "na-correction-results"
        );

        clearMessage(message);

        if (results) {
          results.hidden = true;
        }

        if (
          !Number.isFinite(volume) ||
          !Number.isFinite(currentCalcium) ||
          !Number.isFinite(targetCalcium) ||
          !Number.isFinite(magnesium)
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please complete all four fields.</strong> Enter your actual system water volume and current test results."
          );
          return;
        }

        if (
          volume <= 0 ||
          currentCalcium <= 0 ||
          targetCalcium <= 0 ||
          magnesium <= 0
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please enter numbers greater than zero.</strong>"
          );
          return;
        }

        if (currentCalcium >= targetCalcium) {
          showMessage(
            message,
            "warning",
            "<strong>No calcium correction is needed.</strong> Current calcium is already equal to or higher than the selected target."
          );
          return;
        }

        var calciumIncrease =
          targetCalcium - currentCalcium;

        /*
          Manufacturer concentration:
          1 mL per gallon raises calcium by approximately 10 ppm.
        */
        var totalDose =
          volume * (calciumIncrease / 10);

        /*
          Maximum starting correction:
          5 mL per 10 gallons daily.
        */
        var maximumDailyDose =
          (volume / 10) * 5;

        var estimatedDays =
          Math.ceil(totalDose / maximumDailyDose);

        var fullDays =
          Math.floor(totalDose / maximumDailyDose);

        var finalDose =
          totalDose - fullDays * maximumDailyDose;

        document.getElementById(
          "na-total-dose"
        ).textContent = formatDose(totalDose);

        document.getElementById(
          "na-max-daily-dose"
        ).textContent =
          formatDose(maximumDailyDose) + " per day";

        document.getElementById(
          "na-estimated-days"
        ).textContent =
          estimatedDays === 1
            ? "At least 1 day"
            : "At least " + estimatedDays + " days";

        document.getElementById(
          "na-calcium-increase"
        ).textContent =
          calciumIncrease.toFixed(0) + " ppm";

        var plan =
          "<strong>Estimated dosing plan</strong><p>";

        if (estimatedDays === 1) {
          plan +=
            "The estimated total correction is " +
            formatDose(totalDose) +
            ". This is within the calculated maximum daily amount of " +
            formatDose(maximumDailyDose) +
            ".";
        } else if (finalDose > 0.05) {
          plan +=
            "Do not exceed approximately " +
            formatDose(maximumDailyDose) +
            " per day. This correction would require " +
            fullDays +
            (fullDays === 1
              ? " full day"
              : " full days") +
            " at the maximum rate, followed by approximately " +
            formatDose(finalDose) +
            " on the final day.";
        } else {
          plan +=
            "Do not exceed approximately " +
            formatDose(maximumDailyDose) +
            " per day. The correction would take approximately " +
            estimatedDays +
            " days.";
        }

        plan +=
          " Test calcium during the correction and stop or adjust dosing once the target is reached.</p>";

        document.getElementById(
          "na-dose-plan"
        ).innerHTML = plan;

        if (results) {
          results.hidden = false;
        }

        var notices = [];

        if (magnesium < 1200) {
          notices.push(
            "<strong>Magnesium is below 1,200 ppm.</strong> Use a separate magnesium supplement to bring it into range."
          );
        }

        if (
          targetCalcium < 430 ||
          targetCalcium > 450
        ) {
          notices.push(
            "<strong>Your selected target is outside the recommended calcium range of 430–450 ppm.</strong>"
          );
        }

        if (notices.length > 0) {
          showMessage(
            message,
            "warning",
            notices.join("<br><br>")
          );
        } else {
          showMessage(
            message,
            "success",
            "<strong>Calculation complete.</strong> Treat this result as an estimate and verify the adjustment through testing."
          );
        }
      });
    }

    /* Daily maintenance calculator */
    var maintenanceButton = document.getElementById(
      "na-calculate-maintenance"
    );

    if (maintenanceButton) {
      maintenanceButton.addEventListener("click", function () {
        var volume = getNumber(
          "na-maintenance-volume"
        );

        var dailyDrop = getNumber(
          "na-daily-calcium-drop"
        );

        var message = document.getElementById(
          "na-maintenance-message"
        );

        var results = document.getElementById(
          "na-maintenance-results"
        );

        clearMessage(message);

        if (results) {
          results.hidden = true;
        }

        if (
          !Number.isFinite(volume) ||
          !Number.isFinite(dailyDrop)
        ) {
          showMessage(
            message,
            "error",
            "<strong>Please complete both fields.</strong>"
          );
          return;
        }

        if (volume <= 0 || dailyDrop < 0) {
          showMessage(
            message,
            "error",
            "<strong>Please enter a valid water volume and calcium decrease.</strong>"
          );
          return;
        }

        if (dailyDrop === 0) {
          showMessage(
            message,
            "warning",
            "<strong>No measurable calcium consumption was entered.</strong> A maintenance dose cannot be calculated from a zero ppm decrease."
          );
          return;
        }

        /*
          Manufacturer maintenance formula:
          Gallons × daily calcium decrease ÷ 10
        */
        var dailyDose =
          volume * (dailyDrop / 10);

        var weeklyDose =
          dailyDose * 7;

        document.getElementById(
          "na-maintenance-dose"
        ).textContent =
          formatDose(dailyDose) + " per day";

        document.getElementById(
          "na-weekly-dose"
        ).textContent =
          formatDose(weeklyDose) + " per week";

        if (results) {
          results.hidden = false;
        }

        showMessage(
          message,
          "success",
          "<strong>Maintenance estimate calculated.</strong> Retest regularly and adjust the daily dose according to actual calcium consumption."
        );
      });
    }
  }

  /*
    Run immediately when Shopify has already loaded the page,
    or wait when the page is still loading.
  */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializePartACalculator
    );
  } else {
    initializePartACalculator();
  }

  /*
    Extra fallback for Shopify theme rendering and preview mode.
  */
  setTimeout(initializePartACalculator, 500);
  setTimeout(initializePartACalculator, 1500);
})();